var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLivechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8162 18.1192H22.9537C18.6447 18.1192 15.1191 21.6448 15.1191 25.9538V64.4494C15.1191 68.7584 18.6447 72.2839 22.9537 72.2839H41.3201L49.8877 84.0973L58.4554 72.2839H76.8218C81.1308 72.2839 84.6564 68.7584 84.6564 64.4494V25.9538C84.6564 21.6448 81.1308 18.1192 76.8218 18.1192H76.8162Z",
    stroke: "#344054",
    strokeWidth: 2.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7733 51.1027C34.9907 51.1027 37.5988 48.4946 37.5988 45.2772C37.5988 42.0598 34.9907 39.4516 31.7733 39.4516C28.5559 39.4516 25.9478 42.0598 25.9478 45.2772C25.9478 48.4946 28.5559 51.1027 31.7733 51.1027Z",
    stroke: "#344054",
    strokeWidth: 2.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8822 51.1027C53.0996 51.1027 55.7077 48.4945 55.7077 45.2772C55.7077 42.0598 53.0996 39.4516 49.8822 39.4516C46.6648 39.4516 44.0566 42.0598 44.0566 45.2772C44.0566 48.4945 46.6648 51.1027 49.8822 51.1027Z",
    stroke: "#344054",
    strokeWidth: 2.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9969 51.1027C71.2143 51.1027 73.8225 48.4945 73.8225 45.2772C73.8225 42.0598 71.2143 39.4516 67.9969 39.4516C64.7796 39.4516 62.1714 42.0598 62.1714 45.2772C62.1714 48.4945 64.7796 51.1027 67.9969 51.1027Z",
    stroke: "#344054",
    strokeWidth: 2.24,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.7701,
    height: 69,
    fill: "white",
    transform: "translate(14 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLivechat);
export default __webpack_public_path__ + "static/media/icon_livechat.1ff3bca90a78dd001557f8ab294e58da.svg";
export { ForwardRef as ReactComponent };